import { SITE_URL } from './site'
import { JsonLd } from './JsonLd'

export type Crumb = {
  name: string
  path: string
}

export function BreadcrumbJsonLd({ items }: { items: Crumb[] }) {
  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          item: `${SITE_URL}${item.path === '/' ? '/' : item.path}`,
        })),
      }}
    />
  )
}
